import { STATES } from '@sg-core/src/View/Components/Atoms/Collapse';

export const CLAMPED_CLASS = 'phxsg-text-card__content--clamped';

/**
 * `scrollHeight` and `clientHeight` are rounded to integers, so a fractional line height
 * can make them differ by a pixel on content that actually fits.
 */
const TOLERANCE = 1;

/**
 * Whether the collapse is currently driving the element's height, in which case both its
 * measurements and its inline `height` are off limits.
 */
export function isCollapseAnimating(content: HTMLElement): boolean {
  return content.classList.contains(STATES.TRANSITIONING) || content.classList.contains(STATES.CALCULATING);
}

/**
 * Whether the content does not fit within `lineClamp` lines.
 *
 * When the card is expanded the clamped height has to be applied temporarily (without
 * transition) for the measurement to mean anything.
 */
export function isContentOverflowing(content: HTMLElement, lineClamp: number): boolean {
  if (content.classList.contains(CLAMPED_CLASS)) {
    return content.scrollHeight > content.clientHeight + TOLERANCE;
  }

  const previousTransition = content.style.transition;
  const previousHeight = content.style.height;

  content.style.transition = 'none';
  content.style.height = `calc(${lineClamp} * 1lh)`;

  const overflowing = content.scrollHeight > content.clientHeight + TOLERANCE;

  content.style.height = previousHeight;
  content.getBoundingClientRect();
  content.style.transition = previousTransition;

  return overflowing;
}
